// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"715":"dc386a0f","857":"36caa2b8"}[chunkId] + ".chunk.css";
};